import { IDanhSachMienGiamActionTypes } from "../../action-types/mien-giam/IDanhSachMienGiamActions";

import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachMienGiamReducer } from "../../reducer-model/mien-giam/IDanhSachMienGiamReducer";

const iniState: IDanhSachMienGiamReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mienGiams: [],
  displayMode: window.innerWidth >= 1400 ? "full" : "popup",
  mienGiamIds: [],
  doiTuongID: 0,
  typeStatus: 0,
};
export const danhSachMienGiamReducer = (
  state: IDanhSachMienGiamReducer = iniState,
  action: IDanhSachMienGiamActionTypes
): IDanhSachMienGiamReducer => {
  switch (action.type) {
    case "DANH_SACH_MIEN_GIAM_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "DANH_SACH_MIEN_GIAM_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mienGiams: action.payload,
      };
    case "DANH_SACH_MIEN_GIAM_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DANH_SACH_MIEN_GIAM_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "DANH_SACH_MIEN_GIAM_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        mienGiamIds: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "DANH_SACH_MIEN_GIAM_CHANGE_MIENGIAM_SELECTED_IDS":
      return {
        ...state,
        mienGiamIds: action.payload,
      };
    case "DANH_SACH_MIEN_GIAM_CHANGE_DOI_TUONG":
      return {
        ...state,
        doiTuongID: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DANH_SACH_MIEN_GIAM_CHANGE_TYPE_DISPLAY":
      return {
        ...state,
        typeStatus: action.payload,
      };
    case "DANH_SACH_MIEN_GIAM_DUYET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DANH_SACH_MIEN_GIAM_DUYET_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        mienGiamIds: [],
      };
    case "DANH_SACH_MIEN_GIAM_DUYET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DANH_SACH_MIEN_GIAM_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };
    case "DANH_SACH_MIEN_GIAM_HUY_DUYET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DANH_SACH_MIEN_GIAM_HUY_DUYET_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        mienGiamIds: [],
      };
    case "DANH_SACH_MIEN_GIAM_HUY_DUYET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
